import { ROUTE_DELIMITER } from './Route.mjs';
import { cullDecendants } from '../utils/createCullableNode.mjs';

/**
 * Render the first matching Route child.
 * @usage ./Switch.usage.md
 */
const Switch = (_props, children, utils) => {
    const index = children.indexOf(ROUTE_DELIMITER);
    cullDecendants(children.slice(index), utils);
    return children.slice(0, index);
};

export { Switch };
